import SearchForm from './searchForm';
import ToggleElement from './toggleElement';
import Tabs from './tabs';
import Installments from './installments';

export default function(){
  if (document.querySelector('.js-search-form')) new SearchForm();
  new ToggleElement();
  new Tabs();
  new Installments();
}


/** WEBPACK FOOTER **
 ** ./assets/js/modules/index.js
 **/